/**
 * Converts inches to centimeters.
 *
 * @param {number} inches The number to convert.
 */
const insToCms = ( inches: number ) => inches * 2.54

export default insToCms
